import React from 'react';
import './AdminDataStatus.css';

const AdminDataStatus = ({ 
  cacheHealth, 
  loading, 
  errors, 
  showDetails = false 
}) => {
  if (!showDetails && cacheHealth?.isDataFresh && !cacheHealth?.isLoading) {
    return null; // Don't show anything when data is fresh and ready
  }

  const hasErrors = Object.values(errors || {}).some(error => error !== null);
  const isLoading = Object.values(loading || {}).some(loading => loading);

  return (
    <div className={`admin-data-status ${isLoading ? 'loading' : ''} ${hasErrors ? 'error' : ''}`}>
      <div className="status-content">
        {isLoading && (
          <div className="status-item loading">
            <div className="loading-spinner"></div>
            <span>Loading admin data...</span>
          </div>
        )}

        {hasErrors && (
          <div className="status-item error">
            <span className="error-icon">⚠️</span>
            <span>Data sync issues detected</span>
          </div>
        )}

        {cacheHealth?.isDataFresh && !isLoading && !hasErrors && (
          <div className="status-item success">
            <span className="success-icon">✅</span>
            <span>Data synchronized</span>
          </div>
        )}

        {showDetails && (
          <div className="status-details">
            <div className="status-row">
              <span>Last Update:</span>
              <span>
                {cacheHealth?.lastUpdate 
                  ? new Date(cacheHealth.lastUpdate).toLocaleTimeString()
                  : 'Never'
                }
              </span>
            </div>
            
            {hasErrors && (
              <div className="error-details">
                {Object.entries(errors).map(([collection, error]) => 
                  error && (
                    <div key={collection} className="error-item">
                      <strong>{collection}:</strong> {error}
                    </div>
                  )
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDataStatus;
